Wee.fn.make('accordion', {
    init: function() {
        $.events.on({
            // Toggle Accordion Panels
            'ref:accordion-btn': {
                click: function(e, el) {
                    var $panel = Wee.$siblings(el, '.js-accordion-panel')[0];
                    Wee.$toggleClass(el, '-active');
                    Wee.$toggleClass($panel, '-open');

                    if ($panel.style.maxHeight) {
                        $panel.style.maxHeight = null;
                    } else {
                        $panel.style.maxHeight = $panel.scrollHeight + 'px';
                    }
                }
            }
        });
    }
});

Wee.accordion.init();